import styled from "styled-components";
export const GlobalAdminManageOrganizationViewParent = styled.div ``;
